import { render, staticRenderFns } from "./QuickUser.vue?vue&type=template&id=7810c6da&scoped=true"
import script from "./QuickUser.vue?vue&type=script&lang=js"
export * from "./QuickUser.vue?vue&type=script&lang=js"
import style0 from "./QuickUser.vue?vue&type=style&index=0&id=7810c6da&prod&lang=scss&scoped=true"
import style1 from "./QuickUser.vue?vue&type=style&index=1&id=7810c6da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7810c6da",
  null
  
)

export default component.exports